// Port of Flutter's exitPopup() (homeScreenFunctions.dart) — the "do you want to
// exit?" gate on the hardware back button.
//
// Deliberately NOT themed from the server colours: the Dart hardcodes the
// #0D1A2F surface and blue buttons here, so it looks the same whatever palette
// the company record carries.
//
// Not dismissible by tapping outside — in Flutter it is barrierDismissible:
// false, so the only ways out are the two buttons.

import React from 'react';
import {
  Dialog, Box, Typography, Button,
} from '@mui/material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';

export default function ExitConfirmDialog({
  open,
  title = 'Do You Want to exit ?',
  message = 'Click the button below to exit the app.',
  onExit,
  onCancel,
}) {
  const btnSx = {
    bgcolor: '#1976D2',
    color: '#fff',
    px: 3,
    py: 1.5,
    borderRadius: '8px',
    textTransform: 'none',
    boxShadow: 4,
    '&:hover': { bgcolor: '#1976D2' },
  };

  return (
    <Dialog
      open={open}
      onClose={(_, reason) => {
        // backdropClick / escapeKeyDown must not dismiss it.
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
        onCancel();
      }}
      PaperProps={{ sx: { bgcolor: '#0D1A2F', borderRadius: '16px', m: 2 } }}
    >
      <Box sx={{
        px: 3, py: 2.5, display: 'flex', flexDirection: 'column', alignItems: 'center',
      }}
      >
        <WarningAmberRoundedIcon sx={{ fontSize: 48, color: '#40C4FF' }} />
        <Typography sx={{
          mt: 2, fontFamily: 'Georgia, serif', fontSize: 22, fontWeight: 700,
          color: '#fff', textAlign: 'center',
        }}
        >
          {title}
        </Typography>
        <Typography sx={{
          mt: 1.5, fontSize: 16, color: '#E0E0E0', textAlign: 'center',
        }}
        >
          {message}
        </Typography>

        <Button onClick={onExit} startIcon={<ExitToAppIcon />} sx={{ ...btnSx, mt: 3 }}>
          Exit
        </Button>
        <Button onClick={onCancel} startIcon={<KeyboardReturnIcon />} sx={{ ...btnSx, mt: 3 }}>
          Go Back
        </Button>
      </Box>
    </Dialog>
  );
}
